import { render, staticRenderFns } from "./pieChart.vue?vue&type=template&id=f76066ee&"
import script from "./pieChart.vue?vue&type=script&lang=ts&"
export * from "./pieChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports